module.exports = __webpack_public_path__ + "SumoDigital-c9cfd26c.webp";